function getPostTypes() {
  return [
    {
      name: "external_link",
      displayName: "Page Web",
      icon: "fas fa-external-link-alt"
    },
    { name: "youtube", displayName: "Video YouTube", icon: "fab fa-youtube" },
    { name: "short_post", displayName: "Billet Gemmici", icon: "fas fa-edit" },
    { name: "picture_post", displayName: "Geopic", icon: "$geopic" }
  ];
}
export default getPostTypes;
